<template>

    <v-dialog v-model="show" persistent width="430" max-width="80%" :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? show = false : null}">
        <v-card>
        <v-card-title class="headline">
            <v-icon class="mr-3" color="#2980B9">mdi-cloud-alert</v-icon>Allow Application Notifications
        </v-card-title>

        <v-card-text>
            Allow Tels-App notifications to receive real time push notifications for alarms.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click.stop="show=false">Close</v-btn>
            <v-btn text color="#2980B9" @click.stop="accept">Allow</v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
export default {
    name: 'PushNotificationPermissionDialog',
    props: {
        value: Boolean,
        emailUnverified: Boolean,
        smsUnverified: Boolean,
        onAccept: Function
    },
    data: () => ({
        user: null
    }),

    computed: {
        show: {
            get () {
                return this.value
            },
            set (value) {
                this.$emit('input', value);
            }
        },
    },

    methods: {
        accept: function() {
            this.$props.onAccept();
            this.show = false;
        }
    },

    watch: {
    },

    created() {
    },

    mounted() {
    },
  
};
</script>

<style scoped>


</style>

